import React, {useState} from 'react';
import {ArrowRight, BookOpen, Search, Users} from 'lucide-react';
import {useApiLmGroupList} from "@/api/lms";
import RenderIf from "@/components/render-if";
import {Button, Card} from "antd";
import {Link} from "react-router-dom";
import {URLS} from "@/lib/urls";
import {Coding} from "@/lib/helper/coding";
import SkeletonImage from "antd/es/skeleton/Image";

function LmsGroupListPage(props) {
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const {data: groupsData, isPending, isSuccess} = useApiLmGroupList()

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('fa-IR');
    };


    return (
        <div className="">
            {/* Header Section */}
            <div className=" backdrop-blur-sm border-b border-gray-200/50 top-0 z-50">

                <Link to={URLS.student.dashboard} className={'absolute top-0 right-0 z-50 p-4'}>
                    <button
                        className="flex items-center text-blue-600 hover:text-blue-700 mb-6 transition-colors duration-200"
                    >
                        <ArrowRight className="w-5 h-5 ml-2"/>
                        <span className="font-medium">بازگشت </span>
                    </button>
                </Link>


                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="text-center mb-6">
                        <div className="flex items-center justify-center mb-4">
                            <div className="p-3 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-2xl shadow-lg">
                                <BookOpen className="w-8 h-8"/>
                            </div>
                        </div>
                        <h1 className="text-4xl font-bold  mb-2">
                            آموزش مجازی
                        </h1>
                        <p className="text-lg  max-w-2xl mx-auto">
                            موضوع آموزشی مناسب خود را انتخاب کنید تا در مسیر یادگیری قرار بگیرید
                        </p>
                    </div>

                    {/* Search Bar */}
                    <div className="hidden max-w-md mx-auto relative">
                        <div className="relative">
                            <Search
                                className="absolute right-3 top-1/2 transform -translate-y-1/2  w-5 h-5"/>
                            <input
                                type="text"
                                placeholder="جستجو ..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full pr-12 pl-4 py-3 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Groups Grid */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    <RenderIf condition={isPending}>
                        {[...Array(3)].map((item, index) => (
                            <Card
                                key={'pending-lms-card' + index}
                                loading={isPending}
                                cover={
                                    <SkeletonImage rootClassName={'w-full'} style={{width: '100%', height: '180px'}}
                                                   className={''} active={true}/>
                                }
                            >
                            </Card>
                        ))}

                    </RenderIf>
                    <RenderIf condition={isSuccess && groupsData?.data?.data}>
                        {groupsData?.data?.data?.map((group, index) => (
                            <>

                                <div
                                    key={group.id}
                                    className={`group relative  rounded-3xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer overflow-hidden ${
                                        selectedGroup === group.id ? 'ring-4 ring-blue-500 ring-opacity-50' : ''
                                    }`}

                                    style={{
                                        animationDelay: `${index * 150}ms`,
                                        animation: 'fadeInUp 0.6s ease-out forwards'
                                    }}
                                >
                                    <Link to={URLS.lms.levels + '?id=' + Coding.encode(group.id)}>
                                        {/* Image Container */}
                                        <div className="relative h-48 overflow-hidden">
                                            <img
                                                src={group.file}
                                                alt={group.title}
                                                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                                onError={(e) => {
                                                    const target = e.target;
                                                    target.src = 'https://images.pexels.com/photos/256455/pexels-photo-256455.jpeg';
                                                }}
                                            />
                                            <div
                                                className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>


                                        </div>

                                        {/* Content */}
                                        <div className="p-6">
                                            <h3 className="text-xl font-bold  mb-3 line-clamp-2 group-hover:text-blue-600 transition-colors duration-200">
                                                {group.title}
                                            </h3>

                                            <div className="flex items-center justify-between mb-4">
                                                <div className="flex items-center  text-sm">

                                                </div>
                                                <div className="flex items-center  text-sm">
                                                    <Users className="w-4 h-4 ml-1"/>
                                                    <span>آموزشی</span>
                                                </div>
                                            </div>

                                            {/* CTA Button */}

                                            <button
                                                className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-3 px-6 rounded-2xl font-medium hover:from-blue-600 hover:to-indigo-700 transform hover:scale-[1.02] transition-all duration-200 shadow-lg hover:shadow-xl group">
                                                <div className="flex items-center justify-center">
                                                    <span>شروع یادگیری</span>

                                                </div>
                                            </button>

                                        </div>

                                        {/* Hover Overlay */}
                                        <div
                                            className="absolute inset-0 bg-gradient-to-r from-blue-600/5 to-indigo-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
                                    </Link>
                                </div>
                            </>

                        ))}
                    </RenderIf>
                </div>


                {/* Empty State */}
                <RenderIf condition={(groupsData?.data?.data?.length === 0 && isSuccess)}>
                    <div className="text-center py-16">
                        <div
                            className="w-24 h-24 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
                            <Search className="w-12 h-12 "/>
                        </div>
                        <h3 className="text-xl font-semibold  mb-2">گروهی یافت نشد</h3>
                        <p className="">لطفاً کلمه جستجوی دیگری امتحان کنید</p>
                    </div>
                </RenderIf>
            </div>

            {/* Footer */}
            <footer className=" backdrop-blur-sm border-t border-gray-200/50 mt-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="text-center ">
                        <Link to="/">
                            <Button size={'large'} color={'gold'} variant={'solid'}>بازگشت</Button>
                        </Link>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default LmsGroupListPage;

